<!--
 * @Description: 
 * @LastEditors: Please set LastEditors
 * @Date: 2021-02-01 11:36:38
-->
<template>
  <div class="live-share-card">
    <template v-if="list.length > 1">
      <van-swipe :loop="false" :width="300">
        <van-swipe-item v-for="item in list" :key="item.id">
          <div style="padding:0 .3rem;">
            <img class="img" :src="item.image" />
          </div>
        </van-swipe-item>
      </van-swipe>
    </template>
    <template v-else-if="list.length == 1">
      <div style="padding:0 .3rem;">
        <img class="img" :src="list[0].image" />
      </div>
    </template>
    <p class="live-share-card__text">请长按保存图片到您的相册后进行分享</p>
  </div>
</template>

<script>
import { selectByInvitatioList, queryChannelCourse } from '@/api/course';

export default {
  name: '',
  data() {
    return {
      list: []
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  async created() {
    const id = this.$route.params.id;
    queryChannelCourse({ id }).then(({ pdata }) => {
      let { courseName, videoPicUrl, courseContent, id } = pdata;
      this.$wxShare({
        title: courseName,
        imgUrl: videoPicUrl,
        desc: courseContent,
        callback: () => {
          this.$sa.re_interaction({
            type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
            contentype: '直播', // 互动主体 直播，录播，资讯，病例，站内信，论坛, 调研
            contentid: id, // 内容id
            contentname: courseName
            //  source_user_id: this.$route.query.source_user_id || "", // 邀请人ID 全局使用
            //  projectId: this.$route.query.projectId || ""
          });
        }
      });
    });
    let { pdata } = await selectByInvitatioList({
      courseId: id
    });
    this.list = pdata;
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.live-share-card {
  padding: 0.51rem;
  // height: 14.4rem;
  .img {
    width: 8.65rem;
    height: 13.96rem;
    border-radius: 0.32rem;
  }
  &__text {
    text-align: center;
    font-size: 0.4rem;
    margin-top: 0.3rem;
  }
  .van-swipe {
    height: 15rem;
  }
  .van-swipe__indicator {
    width: 10px;
    height: 10px;
    border: 1px solid #333333;
    border-radius: 50%;
    &--active {
      background-color: #333333;
      border-color: transparent;
    }
  }
}
</style>
